<template>
  <v-row>
    <v-col cols="12">
      <v-data-table
        class="mr-4"
        :headers="historyHeaders"
        disable-filtering
        disable-sort
        :items="history"
        :options.sync="localHistoryOptions"
        :server-items-length="localHistoryCount"
        :loading="loadingHistory"
        :footer-props="{ 'items-per-page-options': [10, 20, 50] }"
      >
        <template #item.actions="{ item }">
          <v-btn color="primary" @click="downloadHistoryRecord(item)" icon>
            <v-icon>mdi-download</v-icon>
          </v-btn>
          <v-btn color="error" @click="openDeleteDialog(item)" icon>
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>

      <v-dialog v-model="deleteDialog" max-width="500">
        <v-card>
          <v-card-title>{{ $t('confirmDeleteTitle') }}</v-card-title>
          <v-card-text>{{ $t('confirmDeleteFile') }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey" text @click="deleteDialog = false">
              {{ $t('cancel') }}
            </v-btn>
            <v-btn
              color="error"
              text
              @click="deleteHistoryRecord(selectedItem)"
            >
              {{ $t('confirmDeletion') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import ExportsService from '@/services/ExportsService'

export default {
  name: 'HistoryTab',
  props: {
    history: {
      type: Array,
      default: () => [],
    },
    loadingHistory: {
      type: Boolean,
      default: true,
    },
    historyCount: {
      type: Number,
      default: 0,
    },
    historyOptions: {
      type: Object,
      default: () => ({
        page: 1,
        itemsPerPage: 10,
      }),
    },
  },
  data() {
    return {
      historyHeaders: [
        { text: this.$t('date'), value: 'created_at' },
        { text: this.$t('file'), value: 'filename' },
        { text: this.$t('rowCount'), value: 'line_count' },
        { text: this.$t('actions'), value: 'actions' },
      ],
      localHistoryCount: 0,
      localHistoryOptions: {
        page: 1,
        itemsPerPage: 10,
      },
      deleteDialog: false,
      selectedItem: null,
    }
  },
  watch: {
    localHistoryOptions: {
      deep: true,
      handler(value) {
        this.$emit('invalidated', value, this.localHistoryCount)
      },
    },
    historyCount: {
      immediate: true,
      handler(value) {
        this.localHistoryCount = value
      },
    },
    historyOptions: {
      immediate: true,
      handler(value) {
        this.localHistoryOptions = value
      },
    },
  },
  methods: {
    async deleteHistoryRecord(item) {
      this.deleteDialog = false
      await ExportsService.deleteFile(this, item.id)

      if (
        !(--this.localHistoryCount % this.localHistoryOptions.itemsPerPage) &&
        this.localHistoryOptions.page > 1
      ) {
        this.localHistoryOptions.page -= 1
      } else {
        this.$emit(
          'invalidated',
          this.localHistoryOptions,
          this.localHistoryCount
        )
      }
    },
    downloadHistoryRecord(item) {
      ExportsService.retrieveFile(this, item.id, item.filename)
    },
    openDeleteDialog(item) {
      this.selectedItem = item
      this.deleteDialog = true
    },
  },
}
</script>
